<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('orders')"
      :columns="columns"
      :column_search="true"
      :extra_buttons="extra_buttons"
      :page_length="100"
      @data_loaded="data_loaded"
      resource_url="/restaurant/order/datatables"
      mode="grouped-table"
      :options="{
        layout: {
          topStart: 'pageLength',
          topEnd: 'search',
          bottomStart: null,
          bottomEnd: null,
        },
        grouping: (data) => {
          let v = this;
          let icon = '';
          if (data.status == 'kitchen_ordered')
            icon = `<span class='icon is-small'><i class='fa fa-cutlery'></i></span>`;
          else if (data.status == 'waiting_delivery')
            icon = `<span class='icon is-small'><i class='fa fa-truck'></i></span>`;
          else if (data.status == 'kitchen_done')
            icon = `<span class='icon is-small'><i class='fa fa-check'></i></span>`;
          else if (data.status == 'delivered')
            icon = `<span class='icon is-small'><i class='fa fa-check'></i></span>`;
          else if (data.status == 'canceled')
            icon = `<span class='icon is-small'><i class='fa fa-times'></i></span>`;

          return `${icon}<span>${v.$t(data.status)}</span>`;
        },
      }"
    >
      <template #item="item">
        <div class="card">
          <div class="card-image">
            <div
              class="is-pulled-right has-text-danger"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </div>
            <figure class="image is-64x64 m-auto" @click="edit(item)">
              <v-lazy-image
                v-if="item.image"
                :src="`${api_host}/drive/static/${item.image}`"
              />
              <img
                v-else
                src="https://icon-library.com/images/product-icon-png/product-icon-png-11.jpg"
              />
            </figure>
          </div>
          <div class="card-content px-0" @click="edit(item)">
            <div class="media">
              <div class="media-content">
                <div class="title is-5 has-text-centered">
                  {{ item }}
                </div>
                <div class="subtitle is-6 has-text-centered">
                  <span class="tag is-primary is-medium">{{
                    format_currency(item.sale_price)
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <footer class="card-footer" v-show="false">
            <a
              class="card-footer-item button"
              :data-tooltip="$t('edit')"
              @click="edit(item)"
            >
              <span class="icon"><i class="fa fa-edit"></i></span>
            </a>
            <a
              class="card-footer-item has-text-danger button"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </a>
            <a
              class="card-footer-item button"
              :data-tooltip="$t('file list')"
              @click="file_list(item)"
            >
              <span class="icon"><i class="fa fa-list"></i></span>
            </a>
          </footer>
        </div>
      </template>
    </generic-table>
  </div>

  <order-modal
    ref="order_modal"
    @success="refresh"
    :module_settings="module_settings"
  />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  put,
  error_message,
  format_currency,
  format_date,
  api_host,
} from "@/utils";
import OrderModal from "./order_modal/Index.vue";
import VLazyImage from "v-lazy-image";

export default {
  name: "OrdersDatatable",
  components: { GenericTable, OrderModal, VLazyImage },
  props: {
    module_settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    let v = this;
    return {
      api_host,
      extra_buttons: [
        // {
        //   text: v.$t("bulk categorize"),
        //   icon: "fa fa-list",
        //   class: "is-secondary is-rounded",
        //   click: this.bulk_categorize,
        // },
        // {
        //   text: v.$t("add"),
        //   icon: "fa fa-plus",
        //   class: "is-secondary is-rounded",
        //   click: this.create,
        // },
      ],
      columns: [
        {
          title: v.$t("customer"),
          name: "customer",
          data: (row) => {
            return `<div class="title is-6">${row.customer} ${row.table}</div>
                    <div class="subtitle is-6">${format_date(
                      row.create_date
                    )}</div>`;
          },
        },
        {
          title: v.$t("items"),
          data: (row) => {
            let list = row.restaurant_order_items.reduce((acc, item) => {
              return `${acc}<li><div class="title is-6">${
                item.product && item.product.name ? item.product.name : ""
              }</div><div class="subtitle is-6">${
                item.settings && item.settings.customization
                  ? item.settings.customization
                  : ""
              }</div></li>`;
            }, "");
            return `<div class="content"><ul>${list}</ul></div>`;
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            let btns = [
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("view"),
                icon: "fa fa-eye",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.order_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete order?"),
                    v,
                    () => {
                      del("/restaurant/order", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ];

            if (row.status != "canceled") {
              btns.push({
                args: { uuid: row.uuid },
                tooltip: v.$t("cancel"),
                icon: "fa fa-times",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to cancel order?"),
                    v,
                    () => {
                      put("/restaurant/order/status", {
                        uuid: uuid,
                        status: "canceled",
                      })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              });

              if (row.status != "delivered")
                btns.push({
                  args: { uuid: row.uuid },
                  tooltip: v.$t("done"),
                  icon: "fa fa-check",
                  icon_class: "is-small has-text-primary",
                  click: (e) => {
                    let uuid = e.detail.uuid;
                    confirm_deletion_dialog(
                      v.$t("are you sure to mark as done?"),
                      v,
                      () => {
                        put("/restaurant/order/done", {
                          uuid: uuid,
                        })
                          .then(() => {
                            v.refresh();
                          })
                          .catch((error) => {
                            error_message(error);
                          });
                      }
                    );
                  },
                });
            }

            return generate_datatables_buttons(btns);
          },
        },
      ],
    };
  },
  methods: {
    format_currency,
    // create() {
    //   let v = this;
    //   v.$refs.product_modal.show_modal();
    // },
    // bulk_categorize() {
    //   let v = this;
    //   v.$refs.bulk_categorize_modal.show_modal();
    // },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    edit(item) {
      let v = this;
      v.$refs.product_modal.show_modal(item.uuid);
    },
    remove(item) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete product?"),
        v,
        () => {
          del("/product", { uuid: item.uuid })
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    data_loaded(data) {
      // let v = this;
      // console.log("data_loaded", data);
    },
  },
  mounted() {
    let v = this;
    v.refresh();
  },
};
</script>

<style></style>
